/**
 * Settings module translations - Table section
 */

const table = {
  companyName: "Nombre de la empresa",
  country: "Jurisdicción",
  peppolNumber: "Número Peppol",
  active: "Activo",
  taxId: "ID fiscal",
  languageForPDFs: "Idioma para PDFs",
  others: "Otros",
  validFrom: "Válido desde",
  validTill: "Válido hasta",
  useForInvoice: "Usar para L'invoice",
  actions: "Acciones",
  number: "#",
  sku: "SKU",
  description: "Descripción",
  classificationCode: "Código de clasificación",
  act: "Acción"
};

export default table;
